export default __webpack_public_path__ + "static/media/card2.8bd83fc9.png";